<template>
    <div class="flex flex-row flex-wrap lg:max-w-[545px]">
        <h2 v-html="field.info.description" class="text-2 mb-10"></h2>
        
        <div>
            <template v-for="(item, index) in field.info.contents">
                <div class="flex flex-col items-start mb-10 last:mb-0 md:flex-row lg:flex-col">
                    <div v-if="item.picture && item.picture.width" class="relative mb-3 w-full md:mb-0 md:w-[58.1395348837%] lg:mb-3 lg:w-full">
                        <ImageBG :image="item.picture.image" class="!relative pb-[59.7014925373%] md:pb-[80%] lg:pb-[47.7064220183%]" image-class="!absolute !left-0 !top-0 !w-full !h-full"/>
                    </div>
                    
                    <div v-else-if="item.picture"
                         class="w-full mb-3 md:flex md:justify-center md:items-end md:w-[184px] md:h-[184px] lg:justify-start lg:mb-3 lg:w-full lg:h-auto" 
                         :class="{'md:items-center md:mb-0 md:bg-blue-20 md:p-3 lg:p-0 lg:bg-transparent': item.picture.mask, 'md:mb-0 md:items-end': !item.picture.mask}">
                        <ImageBG :image="item.picture.image" class="!relative !left-auto !top-auto !w-auto !h-auto" image-class="!w-auto !h-auto"/>
                    </div>
                    
                    <div class="w-full md:self-end  md:ml-6 lg:ml-0 lg:w-full lg:self-auto" :class="{'md:w-[38.3720930233%]': item.picture.width, 'w-[58.2%]': !item.picture.width}">
                        <h3 v-html="item.heading" class="text-h6 mb-1"></h3>
                        <div v-html="item.content" class="text-3"></div>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>
<script>
import DescriptionView from "./DescriptionView";
import DescriptionScrollView from "./DescriptionScrollView";
import ImageBG from "../../../../assets/js/vue/partials/ImageBG.vue";
//<div class="flex flex-row flex-wrap overflow-y-hidden overflow-x-auto">
export default {
    name: 'FiledOptionsInfo',
    components: { ImageBG, DescriptionScrollView, DescriptionView },
    props: {
        field: {},
    },
    computed: {
        descriptions() {
            return this.field.options.map(item => item.description).filter(item => this.showDescription(item));
        },
    },
    methods: {
        showDescription(desc) {
            return !!desc.text || !!desc.header
        }
    }
}
</script>

<style lang="scss" scoped>

</style>